export default "__VITE_ASSET__5dd200c5__"